module.exports = __webpack_public_path__ + "static/media/crowdsale_token.abbebf8e.svg";